<template>
  <div
    class="manager_box"
    style="background:white;min-height:80vh; padding:20px;"
    v-loading="loading"
  >
    <div>
      <el-button type="primary" @click="is_dio=true">操作</el-button>

      <div class="container">
        <div>
          <label>
            <input type="checkbox" v-model="horizontal" /> 是否横向展示
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" v-model="collapsable" /> 是否可被展开
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox" v-model="expandAll" @change="expandChange" /> 是否展开所有
          </label>
        </div>
      </div>
    </div>
    <div class="oTree">
      <vue2-org-tree
        :data="tree_data"
        :horizontal="horizontal"
        :collapsable="collapsable"
        :render-content="renderContent"
        @on-expand="onExpand"
        @on-node-click="onNodeClick"
      />
    </div>
    <el-dialog title="操作" :visible.sync="is_dio">
      <div class="pm_cenetr">
        <div class="el_tree_b">
          <el-tree
            class="el_tree_center"
            :default-expand-all="true"
            accordion
            :data="data"
            :props="defaultProps"
          >
            <div class="slot_tree" slot-scope="{ node }">
              <span>{{ node.label }}</span>

              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <span class="iconfont icongengduo"></span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{node: node, id: 0}">
                    <span class="iconfont iconxiugai"></span> 修改
                  </el-dropdown-item>
                  <el-dropdown-item :command="{node: node, id: 1}">
                    <span class="iconfont iconzengjia"></span> 创建
                  </el-dropdown-item>
                  <el-dropdown-item :command="{node: node, id: 2}">
                    <span class="iconfont iconshanchu1"></span> 删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-tree>
          <el-button size="mini" style="width:100%;margin-top:10px;" @click="create_tree">创建</el-button>
        </div>
        <!-- <div class='department_staff'>
                <div class='employee_setup'>
                    <div>
                        <el-button style="width:120px;" @click="add_employee">添加员工</el-button>
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%" @row-click='go_to_modify'>
                    <el-table-column prop="name" label="姓名" min-width="80"></el-table-column> 
                    <el-table-column prop="age" label="年龄" min-width="60"></el-table-column> 
                    <el-table-column prop="gender_name" label="性别" min-width="60"> </el-table-column>
                    <el-table-column prop="mobile" label="联系方式" min-width="120"> </el-table-column>
                    <el-table-column prop="present_address" label="现住址" min-width="120"> </el-table-column>
                    <el-table-column prop="credit_card_num" label="银行卡号" min-width="180"> </el-table-column>
                    <el-table-column prop="id_card" label="身份证号" min-width="180"> </el-table-column>
                    <el-table-column prop="join_time" label="入职时间" min-width="100"> </el-table-column>
                    <el-table-column prop="create_time" label="创建时间" min-width="100"> </el-table-column>
                </el-table>
        </div>-->
      </div>
    </el-dialog>

    <el-dialog :title="dialog_title" :visible.sync="dialogVisible" class="el_table_class">
      <el-form label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="ed_name"></el-input>
        </el-form-item>
        <el-form-item class="onSubmit">
          <el-button style="width:90px;" type @click="dialogVisible = false">取消</el-button>
          <el-button style="width:90px;" type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { require } from '@/utils/http_request.js'
export default {
  data() {
    return {
      horizontal: false,
      collapsable: true,
      expandAll: false,
      loading: 'false',
      is_dio: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        disabled: 'id',
      },
      tableData: [],
      dialogVisible: false, // 显示添加部门狂
      dialogVisible_id: 0, // 添加/修改
      dialog_title: '添加部门',
      ed_name: '', // 添加部门的名字
      disabled_name: '', // 部门ID
      parent_framework_id: '', //父级id
      tree_data: {},
    }
  },
  created() {
    this.department_staff_list(true)
  },
  computed: {},
  methods: {
    renderContent(h, data) {
      return data.label
    },
    // 节点点击展开/折叠（注意：参数e需要携带）
    onExpand(e, data) {
      if ('expand' in data) {
        data.expand = !data.expand
        if (!data.expand && data.children) {
          this.collapse(data.children)
        }
      } else {
        this.$set(data, 'expand', true)
      }
    },
    // 节点点击
    onNodeClick(e, data) {
      alert(data.label)
    },
    collapse(list) {
      var _this = this
      list.forEach(function (child) {
        if (child.expand) {
          child.expand = false
        }
        child.children && _this.collapse(child.children)
      })
    },
    // 是否全部展开
    expandChange() {
      this.toggleExpand(this.tree_data, this.expandAll)
    },
    toggleExpand(data, val) {
      var _this = this
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this.$set(item, 'expand', val)
          if (item.children) {
            _this.toggleExpand(item.children, val)
          }
        })
      } else {
        this.$set(data, 'expand', val)
        if (data.children) {
          _this.toggleExpand(data.children, val)
        }
      }
    },
    department_staff_list(e) {
      this.loading = true
      require('post', '/lufish_hrm/v1/corporate_structure_list/', {}).then(
        (res) => {
          console.log(res)
          if (!res.code) {
            this.data = res.data
            this.tree_data = {
              id: 0,
              label: '北京三门课科技有限公司',
              children: res.data,
            }
            // console.log(res.data.length, res.data[0].staff_info.length)
            // if(res.data.length > 0 && res.data[0].staff_info.length > 0 && e){
            //     this.tableData = res.data[0].staff_info
            //     console.log('tableData', this.tableData)
            // }
          }
          this.loading = false
        }
      )
      // require('post', '/lufish_hrm/v1/department_staff_list/', {}).then(res=> {
      //     console.log(res);
      //     if(!res.code){
      //         this.data = res.data
      //         if(res.data.length > 0 && res.data[0].staff_list.length > 0 && e){
      //             this.tableData = res.data[0].staff_list
      //             console.log('tableData', this.tableData)
      //         }
      //     }
      //     this.loading = false
      // })
    },
    create_tree() {
      //添加部门按钮
      this.ed_name = ''
      this.disabled_name = ''
      this.dialog_title = '创建'
      this.dialogVisible_id = 0
      this.dialogVisible = true
    },
    onSubmit() {
      if (this.ed_name == '') {
        this.$message.error('创建的内容不能为空')
        return false
      }
      if (this.dialogVisible_id == 0) {
        require('post', '/lufish_hrm/v1/corporate_structure/', {
          label_code: 'create',
          framework_name: this.ed_name,
          parent_framework_id: this.disabled_name,
        }).then((res) => {
          console.log(res)
          if (!res.code) {
            this.dialogVisible = false
            this.department_staff_list()
          }
        })
      } else {
        require('post', '/lufish_hrm/v1/corporate_structure/', {
          label_code: 'update',
          framework_id: this.disabled_name, //本人id
          framework_info: {
            framework_name: this.ed_name, //本级name
            parent_framework_id: this.parent_framework_id || '', //父级id
          },
        }).then((res) => {
          console.log(res)
          if (!res.code) {
            this.dialogVisible = false
            this.department_staff_list()
          }
        })
      }
    },
    handleNodeClick(data) {
      console.log(data)
      this.tableData = data.staff_info
      // this.tableData = data.staff_list
    },
    add_employee() {
      // 添加
      this.$router.push({ name: 'add_employee' })
    },
    go_to_modify(row) {
      this.$router.push({
        name: 'add_employee',
        params: { staff_id: row.staff_id },
      })
    },
    handleCommand(command) {
      console.log('command', command)
      this.ed_name = command.node.label
      this.parent_framework_id = command.node.data.parent_framework_id
      this.disabled_name = command.node.disabled

      if (command.id == 0) {
        this.dialog_title = '修改'
        this.dialogVisible_id = 1
        this.dialogVisible = true
      } else if (command.id == 1) {
        this.ed_name = ''
        this.dialog_title = '创建'
        this.dialogVisible_id = 0
        this.dialogVisible = true
      } else if (command.id == 2) {
        this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          require('post', '/lufish_hrm/v1/corporate_structure/', {
            label_code: 'delete',
            framework_id: this.disabled_name,
          }).then((res) => {
            console.log(res)
            if (!res.code) {
              this.department_staff_list()
            }
          })
        })
      }
    },
  },
}
</script>

<style>
.pm_cenetr {
  min-height: 70vh;
  display: flex;
}
.el_tree_b {
  border-right: 1px #efefef solid;
  width: 100%;
  padding-right: 12px;
  box-sizing: border-box;
}
.department_staff {
  overflow: auto;
  width: 100%;
  margin-left: 20px;
}
.employee_setup {
  display: flex;
  justify-content: flex-end;
}
.screen_center {
  padding-right: 20px;
}

.slot_tree {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.slot_tree span {
  font-size: 16px;
}
.onSubmit {
  display: flex;
  justify-content: flex-end;
}
.oTree {
  margin-top: 50px;
  text-align: center;
  width: 100%;
  height: 100%;
}

.oTree >>> .org-tree-node-label-inner {
  white-space: nowrap;
  background-color: white;
  border-radius: 5px;
  padding: 10px 20px;
  border: 2px #ccc solid;
}
.container {
  float: right;
  width: 600px;
}
.container > div {
  float: left;
  width: 130px;
  margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/personnel_matters/organizational_structure.vue